import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { add, format } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { cn } from '@fortem-monorepo/js-utilities';
import { Button } from './button';
import { Calendar } from './calendar';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import TimePicker from './time-picker';
export const DatetimePicker = ({ selected, onSelect, defaultTime, }) => {
    const [date, setActualDate] = useState(selected ??
        new Date(new Date().setHours(defaultTime?.hours ?? 0, defaultTime?.minutes ?? 0, defaultTime?.seconds ?? 0, 0)));
    useEffect(() => {
        if (!selected)
            return;
        if (selected.getTime() !== date.getTime()) {
            setActualDate(selected);
        }
    }, [selected, date]);
    const emitDate = (nextDate) => {
        setActualDate(nextDate);
        onSelect(nextDate);
    };
    const handleSelect = (newDay) => {
        if (!newDay)
            return;
        const diff = newDay.getTime() - date.getTime();
        const diffInDays = diff / (1000 * 60 * 60 * 24);
        const newDateFull = add(date, { days: Math.ceil(diffInDays) });
        emitDate(newDateFull);
    };
    return (_jsxs(Popover, { children: [_jsx(PopoverTrigger, { asChild: true, children: _jsxs(Button, { variant: "outline", className: cn('justify-start text-left font-normal', !selected && 'text-muted-foreground'), children: [_jsx(CalendarIcon, { className: "mr-2 h-4 w-4" }), selected ? format(selected, 'PPP HH:mm:ss') : _jsx("span", { children: "Pick a date and time" })] }) }), _jsxs(PopoverContent, { className: "w-auto p-0", children: [_jsx(Calendar, { mode: "single", selected: selected, onSelect: handleSelect, initialFocus: true }), _jsx("div", { className: "p-3 border-t border-border", children: _jsx(TimePicker, { date: date, setDate: (d) => {
                                if (d) {
                                    emitDate(d);
                                }
                            } }) })] })] }));
};
